import React, { FC } from 'react';
import { CardContent, Grid } from '@material-ui/core';
import { unionBy } from 'lodash';

import { useContent } from 'hooks';
import { UserAvatar } from 'components';

const Engagements: FC = () => {
  const { reacted_by, shared_by, commented_by } = useContent();
  const uniqueUsers = unionBy(reacted_by, shared_by, commented_by, 'id');
  const sliced = uniqueUsers.reverse().slice(0, 8);

  if (!uniqueUsers.length) {
    return null;
  }

  return (
    <CardContent>
      <Grid container spacing={1}>
        {sliced.map(user => (
          <Grid item key={user.id}>
            <UserAvatar user={user} link />
          </Grid>
        ))}
      </Grid>
    </CardContent>
  );
};

export default Engagements;
